/**
 * The shared suggestion-chip roster. Every AI-composer surface picks its chips
 * from here — rotate seasonal use-cases (Hot Sale → CyberDay → …) or reword a
 * prompt in this file only, never in a component.
 */
export type SuggestionChip = {
  label: string;
  /** Sent as the chat's opening message when the chip is clicked. */
  prompt: string;
};

export const CHIP_ADS_META: SuggestionChip = {
  label: "Ads para Meta",
  prompt: "Quiero ads para Meta",
};

export const CHIP_ADS_TIKTOK: SuggestionChip = {
  label: "Ads para TikTok",
  prompt: "Quiero ads para TikTok",
};

export const CHIP_REELS_COLABORATIVOS: SuggestionChip = {
  label: "Reels colaborativos",
  prompt: "Quiero reels colaborativos",
};

export const CHIP_VIDEOS_MERCADO_LIBRE: SuggestionChip = {
  label: "Videos para Mercado Libre",
  prompt: "Quiero videos para Mercado Libre",
};

export const CHIP_CREADORES_TIKTOK: SuggestionChip = {
  label: "Activar creadores en TikTok",
  prompt: "Quiero activar creadores en TikTok",
};

/** Seasonal slot — swap for CyberDay etc. here. */
export const CHIP_HOT_SALE: SuggestionChip = {
  label: "Contenido para Hot Sale",
  prompt: "Quiero contenido para el Hot Sale",
};

/** The "Nueva campaña" (1a) composer roster. Chips past the third are
 * progressively hidden on narrower viewports — see `SuggestionChips`. */
export const NEW_CAMPAIGN_CHIPS: SuggestionChip[] = [
  CHIP_ADS_META,
  CHIP_ADS_TIKTOK,
  CHIP_REELS_COLABORATIVOS,
  CHIP_VIDEOS_MERCADO_LIBRE,
  CHIP_CREADORES_TIKTOK,
];
